import {
  MenuItem,
  Select,
  Stack,
  TextField,
  Autocomplete,
  Grid,
} from "@mui/material"
import { useEffect, useState } from "react"
import Modal from "../ui/Modal"
import FormItem from "../ui/FormItem"
import { createAccount, editAccount, searchDepositor } from "../../api"
import { useSnackbar } from "notistack"

const AddAccount = ({
  data,
  setAccountID = () => {},
  refresh = () => {},
  ...props
}) => {
  const { enqueueSnackbar } = useSnackbar()
  const [loading, setLoading] = useState(false)
  const accountTypes = [
    { label: "BANK", value: "BANK" },
    { label: "CASH", value: "CASH" },
  ]

  const [accountDetails, setAccountDetails] = useState({
    accountName: "",
    type: "BANK",
    accountHolder: "",
    branchName: "",
    ifsc: "",
    totalBalance: 0,
    currency: "INR",
  })
  const [inputValue, setInputValue] = useState()
  const [students, setStudents] = useState([])
  const handleChange = (event) => {
    const { name, value } = event.target
    setAccountDetails({
      ...accountDetails,
      [name]: value,
    })
  }

  const chooseFunc = () =>
    data ? editAccount(accountDetails) : createAccount(accountDetails)

  const handleSubmit = () => {
    setLoading(true)
    chooseFunc()
      .then((res) => {
        enqueueSnackbar(`Account ${data ? "edited" : "added"}.`, {
          variant: "success",
        })
        refresh()
        setAccountID(res.data.id)
        props.close()
      })
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setLoading(false))
  }

  const [searching, setSearching] = useState(false)

  const searchStudents = (value) => {
    setSearching(true)
    searchDepositor(value)
      .then((res) =>
        setStudents(res.data.rows.map((r) => ({ ...r, label: r.name })))
      )
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setSearching(false))
  }

  useEffect(() => {
    if (data)
      setAccountDetails({
        id: data.id,
        accountName: data.accountName,
        owner: data.owner,
        type: data.type,
        accountHolder: data.accountHolder,
        branchName: data.branchName,
        ifsc: data.ifsc,
        totalBalance: data.totalBalance,
        currency: data.currency,
      })
    else
      setAccountDetails({
        accountName: "",
        type: "BANK",
        accountHolder: "",
        branchName: "",
        ifsc: "",
        totalBalance: 0,
        currency: "INR",
      })
  }, [data])

  return (
    <Modal
      {...props}
      title={`${data ? "Edit" : "Add"} Account`}
      actionText={data ? "Update" : "Add"}
      action={handleSubmit}
      loading={loading}
    >
      <Stack>
        <Stack direction={"column"} spacing={2} alignItems="center">
          <FormItem label="Account Name">
            <TextField
              name="accountName"
              value={accountDetails.accountName}
              onChange={handleChange}
            />
          </FormItem>
          <FormItem label="Account type">
            <Select
              name="type"
              value={accountDetails.type}
              onChange={handleChange}
            >
              {accountTypes.map((type) => (
                <MenuItem value={type.value}>{type.label}</MenuItem>
              ))}
            </Select>
          </FormItem>
        </Stack>
        <Stack direction={"row"} spacing={2} alignItems="center">
          <FormItem label="Balance">
            <Grid container spacing={1} width={"100% "}>
              <Grid item xs={3}>
                <Select
                  name="currency"
                  value={accountDetails.currency}
                  onChange={handleChange}
                  fullWidth
                >
                  <MenuItem value="INR">₹</MenuItem>
                  <MenuItem value="USD">$</MenuItem>
                </Select>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  name="totalBalance"
                  value={accountDetails.totalBalance}
                  onChange={handleChange}
                  fullWidth
                  type={"number"}
                />
              </Grid>
            </Grid>
          </FormItem>
        </Stack>

        <Stack direction={"row"} spacing={2} alignItems="center">
          <FormItem label="Account Manager">
            <Autocomplete
              loading={searching}
              value={accountDetails.owner}
              onChange={(_, newValue) => {
                setAccountDetails({
                  ...accountDetails,
                  owner: newValue?.id,
                })
              }}
              inputValue={inputValue}
              onInputChange={(_, newInputValue) => {
                setInputValue(newInputValue)
                searchStudents(newInputValue)
              }}
              getOptionLabel={(option) => option.name}
              options={students}
              renderInput={(params) => <TextField {...params} />}
            />
          </FormItem>
        </Stack>
        {accountDetails.type === "BANK" && (
          <>
            <FormItem label="Account Holder">
              <TextField
                name="accountHolder"
                value={accountDetails.accountHolder}
                onChange={handleChange}
              />
            </FormItem>
            <Stack direction={"row"} spacing={2} alignItems="center">
              <FormItem label="Branch Name">
                <TextField
                  name="branchName"
                  value={accountDetails.branchName}
                  onChange={handleChange}
                />
              </FormItem>
              <FormItem label="IFSC Code">
                <TextField
                  name="ifsc"
                  value={accountDetails.ifsc}
                  onChange={handleChange}
                />
              </FormItem>
            </Stack>
          </>
        )}
      </Stack>
    </Modal>
  )
}

export default AddAccount
